import { Get,Post} from "../utils/fetch";
//查询职位参数
export interface CompanyInfoQueryParams extends Common.PageQuery {
    realNameAuthentication?: string;
    sortColumn?: string;
    sortDirections?: string;
}

//单位信息
export interface CompanyVO {
    id?: number;
    fullName: string;   //公司全称
    shortName?: string;   //公司简称
    showNameType?: number;   //职位显示公司名类型（1：全称；2：简称）
    showCompanyName?: string;   //显示公司名称
    logo?: string;   //公司logo
    logoCos?: Common.TencentCos;
    logoTencentCos?: Common.TencentCos;
    constantCompanyTypeId?: number;      //企业性质id
    constantCompanyType?: Common.Constant;
    companyType?: Common.Constant;
    constantCompanySizeId?: number;      //企业规模id
    constantCompanySize?: Common.Constant;
    companySize?: Common.Constant;
    constantFinancingStageId?: number;      //融资阶段ID
    constantFinancingStage?: Common.Constant;      //融资阶段ID
    constantIndustryList?: Common.Constant[];     //行业 
    industryList?: IndustryList[];     //行业 
    
    companyIndustryList?: Common.Constant[];     //行业
    constantLabelList?: Common.Constant[];     //标签
    labelList?: Common.Constant[];     //标签
    companyPage?: string;    //公司主页

    workingHoursStart?: string;    //工作时间（起）
    workingHoursEnd?: string;    //工作时间（止）
    constantOvertimeConditionId?: number;      //加班情况ID
    constantOvertimeCondition?: Common.Constant;
    overtimeCondition?: Common.Constant;
    constantRestTimeId?: number;      //休息时间ID
    constantRestTime?: Common.Constant;
    restTime?: Common.Constant;
    constantWelfareList?: Common.Constant[];     //福利待遇
    welfarelList?: Common.Constant[];     //福利待遇
    contactsObj?: CompnayContacts;      //联系人对象
    contacts?: CompnayContacts;
    areaIds?: number;      //所在地区IDS
    areaNames?: string;    //所在地区名称
    locationId?: number;
    location?: {
        province?: {
            id?: number;
            name?: string;
        };
        city?: {
            id?: number;
            name?: string;
        };
        showText?: string;    //拼接省市
    };
    position?: string;    //公司地址
    zipCode?: string;    //邮政编码
    lon?: string;    //经度
    lat?: string;    //纬度

    describle?: string;    //公司简介
    backgoundImagePath?: string;    //公司背景图

    imgList?: CompnayImage[];     //公司图
    videoIntro?: string;    //公司视频介绍
    // videoList?: Array<CompnayVideo>;     //公司视频
    videoReview?: {
        id?: number;
        type?: number;          //类型 1 公司 2 个人 3 视频宣讲会 4自媒体5 校招活动
        sts?: number;          //状态 0 待审核 1 审核通过(同步百度中) 2 审核未通过 6 同步百度成功 4 百度同步失败 5 百度转码中 3百度转码成功 7百度转码失败
        baiduJobId?: string;  //百度jobid，用来查询百度转码状态
        baiduVideoKey?: string;  //百度视频key，通过该key 获取
        originalFileName?: string;  //原始文件名称
        videoImage?: string;  //频视截图
        videoPath?: string;  //视频路径
        checkTime?: string;  //审核时间
        createTime?: string;
        rmk?: string;  //备注
    };

    qrCode?: string;    //公司二维码
    showAreaInRecruitment?: number;    //是否在发布的职位中显示位置信息（0：否；1：是）
    companySource?: number;    //企业来源（101：企业注册；102：学校注册；200：数据导入；301：长春新区）
    companyStatus?: number;    //公司状态 （1 正常 2 冻结 3 停用 4：注册申请）


    organizationCode?: string;   //上传组织机构代码
    businessLicencePath?: string;   //公司营业执照
    businessLicenceTypeId?: number;   //营业执照类型ID
    businessLicenceState?: string;   //营业执照状态（0：未审核；1：通过；2：不通过）
    businessLicenceAuditTime?: string;   //工商审核时间
    businessLicenceAuditOpinion?: string;   //工商审核意见

    realNameAuthenticationType?: number;   //实名认证方式（1：e签宝；2：线下）
    realNameAuthentication?: number;   //实名认证（0：未认证；1：认证中；2：已认证；3：认证失败）
    realNameAuditTime?: string;   //实名审核时间
    realNameAuditOpinion?: string;   //实名审核意见

    companyBusinessLicense?: CompanyBusinessLicense;   //营业执照对象
    userInfo?: UserInfo;   //营业执照对象
    createTime?: string;
    updateTime?: string;
}
//营业执照对象
export interface CompanyBusinessLicense {
    id: number;
    companyInfoId?: number;      //企业ID
    companyName?: string;   //企业名称
    unifiedSocialCreditCode?: string;   //统一社会信用代码
    companyType?: string;   //企业类型
    companyResidence?: string;   //企业住所
    constantBusinessLicenseTypeId?: number;   //新证书类型ID
    constantBusinessLicenseType?: {
        id: number;
        content?: string;      //内容
        isUsed?: number;   //是否在用（0：否；1：是）
        showLevel?: number;   //显示等级
        topClass?: number;   //层级
        higherLevelId?: number;   //上级ID
        hasSubset?: number;   //是否有子集（0：否；1：是）
    };
    businessLicenseNumber?: string;   //营业执照编号
    businessLicensePath?: string;   //营业执照地址
    businessLicenseCosId?: number;   //营业执照cosId
    businessLicenseCos?: Common.TencentCos;
    businessScope?: string;   //经营范围
    businessTerm?: string;   //营业期限
    establishmentDate?: string;   //成立时间
    legalRepresentative?: string;   //法定代表人
    registeredCapital?: string;   //注册资本
    registeredCapitalCur?: string;   //注册资本币种
    registeredCapitalNum?: number;   //注册资本金额（万元）
    registrationAuthority?: string;   //登记机关
    registrationDate?: string;   //登记时间

    proxyStatementPath?: string;   //单位委托书地址
    proxyStatementPathCosId?: number;   //单位委托书地址cosId
    proxyStatementPathCos?: Common.TencentCos;

    supportingProofPath1?: string;   //辅助证明图片地址1
    supportingProofPath1Path?: string;   //辅助证明图片地址2
    supportingProofPath1CosId?: number;   //辅助证明图片地址1cosId
    supportingProofPath1Cos?: Common.TencentCos;
    proxyStatementPathPath?: string;   //辅助证明图片地址2

    supportingProofPath2?: string;   //辅助证明图片地址2
    supportingProofPath2Path?: string;   //辅助证明图片地址2
    supportingProofPath2CosId?: number;   //辅助证明图片地址2cosId
    supportingProofPath2Cos?: Common.TencentCos;

    supportingProofPath3?: string;   //辅助证明图片地址3
    supportingProofPath3Path?: string;   //辅助证明图片地址2
    supportingProofPath3CosId?: number;   //辅助证明图片地址3cosId
    supportingProofPath3Cos?: Common.TencentCos;

    workProofPath1?: string;   //工作证明图地址1
    workProofPath1CosId?: number;   //工作证明图地址1cosId
    workProofPath1Cos?: Common.TencentCos;
    workProofPath2?: string;   //工作证明图地址2
    workProofPath2CosId?: number;   //工作证明图地址2cosId
    workProofPath2Cos?: Common.TencentCos;
    workProofPath1Path?: string;   //工作证明图地址2
    workProofPath2Path?: string;   //工作证明图地址2

    sealStatus?: number;   //印章状态（0：未上传；1：新上传；2：变更；3：通过；4：不通过）
    sealLocalPath?: string;   //印章地址
    sealLocalPathCosId?: number;   //印章地址cosId
    sealLocalPathCos?: Common.TencentCos;
    sealExamineRmk?: string;   //印章审核意见
    sealCreateTime?: string;   //印章上传时间

    qrCodePath?: string;   //二维码地址
    createTime?: string;   //创建时间

}
//福利待遇
export interface CompnayWelfare {
    id: number;
    workingHoursEnd: string;
    workingHoursStart: string;
    constantOvertimeCondition: { id: number; content: string; };
    constantRestTime: { id: number; content: string; };
    constantWelfareList: Common.Constant[];
}
//单位图片
export interface CompnayImage {
    id: number;
    companyId: number;
    imageDes?: string;
    imagePath?: string;
    imageType: number;
    isDefault: number;
    tencentCosId: number;
    tencentCos: {
        id: number;
        inUsed: number;
        fileName?: string;
        fileSize: number;
        fileHeight: number;
        fileWidth: number;
        fileType: string;
        tencentUrl: string;
        tencentKey: string;
        tencentCoverUrl: string;
        createTime: string;
    };
}
//联系人
export interface CompnayContacts {
    id?: number;
    companyId: number;
    contactsName?: string;
    contactsJob?: string;
    contactsMobile?: string;
    contactsTel?: string;
    contactsEmail?: string;
}
export interface UserInfo {
    id: number;
    username?: string;
    name?: string;
    uniqueCode?: string;
    avatarPath?: string;
    password?: string;
}
export interface IndustryList {
    id?: number;
    companyId: number;
    levelRanking?: string;
    industry?: Common.Constant
}
//列表
export type CompanyVOTableList = CompanyVO
export interface ExamineCompanyRealNameReq {
    companyId: number;
    realNameAuthentication?: number;//实名认证（2：已认证；3：认证失败）
    realNameAuditOpinion?: string; //实名审核意见
}
//获取公司详细
export async function requestGetCompanyInfoById(params: { id?: number }) {
    return Get('/enterprise/direct/companyInfo', params, false);
}
//获取企业查询工商信息
export async function requestGetQichachaByCompanyId(params: { companyId?: number }) {
    return Get('/wechat/qichacha/getQichachaByCompanyId', params, false);
}
//获取企业查询工商信息
export async function requestGetQichachaByCompanyId2(params: { companyId?: number,companyName?: string }) {
    return Get('/wechat/direct/qichacha/getQichachaByCompanyId4', params, false);
}
//获取企业查询工商信息
export async function requestGetQichachaByCompanyId3(params: { companyId?: number ,companyName?: string}) {
    return Get('/wechat/direct/qichacha/getQichachaByCompanyId3', params, false);
}
//获取企业查询工商信息
export async function requestGetQichachaByCompanyId4(params: { companyId?: number,companyName?: string}) {
    return Get('/wechat/direct/qichacha/getQichachaByCompanyId4', params, false);
}

export interface QichachaVO {
    companyId: number;
    companyInfoId: number;
    id?: number;//
    resultCode?: number;//返回code（0：异常；1：成功）
    createTime?: string;
    resultMsg?: string; //返回说明
    tokenJson?: string;
    updateTime?: string;
    qichachaCompany?: QichachaCompany;   //企查查
}
export interface QichachaCompany {
    address?: string;
    belongOrg?: string;
    checkDate?: string;
    creditCode?: string;
    econKind?: string;
    endDate?: string;
    entType?: string;// "":"0",
    imageUrl?: string;
    isOnStock?: string;//"":"0",
    keyNo?: string;
    name?: string;
    no?: string;
    operId?: string;
    operName?: string;
    orgNo?: string;
    province?: string;
    recCap?: string;
    registCapi?: string;
    resultCode?: number;
    resultMsg?: string;
    scope?: string;
    startDate?: string;
    status?: string;
    teamEnd?: string;
    termStart?: string;
    updateDate?: string;
    stockType?: string;
    stockNumber?: string;
    createTime?: string;
}

export interface CompanyImages {
    companyId?: number;
    tencentCosId?: number;
    id?: number;
    imageType?: number;
    isDefault?: number;
    tencentCos?: Common.TencentCos;
    imagePath?: string;
}

//公司环境
export async function getImageListData(params: { companyId?: number}) {
     return Get('/enterprise/direct/companyImage/getImageList', params, false);
}
export interface CompanyStatistics {
    companyId?: number;
    jobNum?: number;
    recruitmentNum?: number;
}
//公司职位统计
export async function getCompanyJobStatistics(data:{companyId?: number,collegeId?: number }, token:boolean) {
    return Post('/enterprise/direct/companyInfo/getCompanyJobStatistics',data, {}, token);
}

//获取学校全部职位
export async function getCollegePositionForStudent(params: { companyId?: number,collegeId?: number,current?: number,pageSize?: number}) {
    return Get('/school/direct/positionApply/getCollegePositionForStudent', params, false)
}
//获取企业职位列表（新）
export async function getCompanyJobList2(params: { companyId?: number,collegeId?: number }) {
    return Get('/enterprise/direct/recruitmentInfo/getCompanyJobList2', params, false)
}
//获取学校下全部职位 
export interface CollegeRecruitment {
    id: number,
    positionName: string;
    jobTypeId?: number;     //工作类型（1：全职；3：实习
    jobTypeList?: Array<Common.Constant>;    //工作类型（1：全职；3：实习
    postNum?: number;     //岗位数（招聘人数）
    repleaseStatus: number;     //发布状态(0 未发布 1 发布 2停止发布)
    enterRepleaseStatus: number;     //发布到学校的状态(1 发布 2停止发布)
    enterStatus: number;     //审核状态(0 待审核 1 审核通过 2审核未通过)
    enterTime?: string;     //职位入驻时间
    enterApplyId: number;     //职位申请ID
    enterAuthId: number;     //职位审核ID

    groupId?: number;     //职位组id
    jobSource?: number;     //职位来源（101：企业注册；102：学校注册；200：数据导入；301：长春新区）
    paySalary?: string;     //薪酬（手填）
    jobDes?: string;       //职位描述
    createTime?: string;    //创建时间
    endTime?: string;       //截止时间
    activitesApplyId?: number;     //活动申请ID
    activitesJobStatus?: number;     //活动职位审核状态（0：待审核；1：通过；2：不通过）
    collegeJobId?: number;     //职位学校入驻ID
    collegeJobStatus?: number;     //职位学校入驻状态

    workingDeadlineStart?: string;    //实习开始时间
    workingDeadlineEnd?: string;    //实习结束时间

    companyInfo?: {     //单位对象
        id?: number,
        fullName?: string;
        logoPath?: string;
        logo?: string;
        memUserName?: string;
    }
    degreeDemand?: Common.Constant;    //学历对象
    degreeStart?: Common.Constant;    //学历对象
    jobStatistics?: {           //统计
        applyCollegeNum?: number,       //职位申请入驻学校数
        eneterCollegeNum?: number;      //职位已入驻学校数
        releaseCollegeNum?: number,       //职位发布中学校数
        resumeDeliveryNum?: number;      //收到简历投递数
    };
    // jobTypeList?: Array<Common.Constant>;      //工作类型
    paySettlementType?: Common.Constant;    //结算方式对象
    payType?: Common.Constant;    //薪酬方式对象
    positionList?: Array<Common.Constant>;      //职位类别
    professionList?: Array<Common.Constant>;      //专业要求
    totalIncomeStart?: Common.Constant;    //薪酬下限对象
    totalIncomeEnd?: Common.Constant;    //薪酬下限对象
    userInfo?: {     //用户对象
        id?: number,        //用户id
        name?: string;      //用户姓名
        uniqueCode?: string;      //uniqueCode
        avatarPath?: string;      //头像地址
    };
    workPlaceList?: Array<LocationVO>;   //工作城市对象
    recruitmentGroup?:{
        id?: number;
        recruitmentNum?: number;
    }
}
export interface LocationVO {
    id?: number;
    countryRegion?: Common.Constant;    
    province?: Common.Constant;    
    city?: Common.Constant;    
    district?: Common.Constant;   
    showText?: string; 
}

//职位详情
export interface RecruitmentInfo {
    id: number,
    positionName?: string;
    jobTypeId?: number;     //工作类型（1：全职；3：实习
    jobTypeList?: Array<Common.Constant>;    //工作类型（1：全职；3：实习
    postNum?: number;     //岗位数（招聘人数）
    repleaseStatus?: number;     //发布状态(0 未发布 1 发布 2停止发布)
    groupId?: number;     //职位组id
    jobSource?: number;     //职位来源（101：企业注册；102：学校注册；200：数据导入；301：长春新区）
    paySalary?: string;     //薪酬（手填）
    jobDes?: string;       //职位描述
    createTime?: string;    //创建时间
    endTime?: string;       //截止时间
    activitesApplyId?: number;     //活动申请ID
    activitesJobStatus?: number;     //活动职位审核状态（0：待审核；1：通过；2：不通过）
    collegeJobId?: number;     //职位学校入驻ID
    collegeJobStatus?: number;     //职位学校入驻状态

    isSolveHukou?: number;     //是否解决户口（0：不解决户口；1：符合条件解决户口）

    workingDeadlineStart?: string;    //实习开始时间
    workingDeadlineEnd?: string;    //实习结束时间
    weeklyWorkingHours?: number;     //周工作时间（天）
    becomeRegularWorker?: number;     //是否转正机会（0：否；1：是）

    companyInfo?: {     //单位对象
        id?: number,
        fullName?: string;
    }
    degreeDemand?: Common.Constant;    //学历对象
    degreeStart?: Common.Constant;    //学历对象
    jobStatistics?: {           //统计
        applyCollegeNum?: number,       //职位申请入驻学校数
        eneterCollegeNum?: number;      //职位已入驻学校数
        releaseCollegeNum?: number,       //职位发布中学校数
        resumeDeliveryNum?: number;      //收到简历投递数
    };
    // jobTypeList?: Array<Common.Constant>;      //工作类型
    paySettlementType?: Common.Constant;    //结算方式对象
    payType?: Common.Constant;    //薪酬方式对象
    positionList?: Array<Common.Constant>;      //职位类别
    professionList?: Array<Common.Constant>;      //专业要求
    politicalStatusList?: Array<Common.Constant>;      //政治面貌
    totalIncomeStart?: Common.Constant;    //薪酬下限对象
    totalIncomeEnd?: Common.Constant;    //薪酬下限对象
    userInfo?: {     //用户对象
        id?: number,        //用户id
        name?: string;      //用户姓名
        uniqueCode?: string;      //uniqueCode
        avatarPath?: string;      //头像地址
    };
    workPlaceList?: Array<LocationVO>;   //工作城市对象
    jobResponsibilityDescribe?: string;//职位描述
    industryList?: Array<Common.Constant>; //行业
    detailedAddress?: string;//详细地址
    recruitmentGroup?:{
        id?: number;
        recruitmentNum?: number;
    }
}
//获取职位详细
export async function getJobDetail(params: { id?: number,collegeId?: number }) {
    return Get('/enterprise/direct/recruitmentInfo', params,false );
}
//获取职位详细
export async function getJobDetailById(params: { id?: number }) {
    return Get('/enterprise/direct/getJobVoById', params,false );
}